import Link from 'next/link';
import { ChevronRight } from 'lucide-react';
import styles from './SectionHeader.module.css';

interface Props {
  kicker?: string;
  title: string;
  sub?: string;
  action?: { label: string; to: string };
  /**
   * Round 3 "open" variant: a hairline-ruled section header with a single
   * mono small-caps label ("KICKER — TITLE") and the action on the right.
   * Default false keeps the original stacked header (used by groups + the
   * mixed feed) untouched.
   */
  open?: boolean;
}

export function SectionHeader({ kicker, title, sub, action, open = false }: Props) {
  if (open) {
    return (
      <header className={styles.openHeader}>
        <span className={`t-mono ${styles.openLabel}`}>
          {kicker ? `${kicker} — ${title}` : title}
        </span>
        {action && (
          <Link href={action.to} className={styles.action}>
            {action.label}
            <ChevronRight width={12} height={12} strokeWidth={1.75} />
          </Link>
        )}
      </header>
    );
  }

  return (
    <header className={styles.header}>
      <div className={styles.titles}>
        {kicker && (
          <div className="t-mono" style={{ color: 'var(--text-tertiary)' }}>
            {kicker.toUpperCase()}
          </div>
        )}
        <h2 className={styles.title}>{title}</h2>
        {sub && (
          <p className="t-meta" style={{ color: 'var(--text-tertiary)', margin: 0 }}>
            {sub}
          </p>
        )}
      </div>
      {action && (
        <Link href={action.to} className={styles.action}>
          {action.label}
          <ChevronRight width={12} height={12} strokeWidth={1.75} />
        </Link>
      )}
    </header>
  );
}
